module.exports = __webpack_public_path__ + "img/9788960170971.c8ed0be4.jpg";